import React from "react";
import { Link } from "react-scroll";
import { MDBIcon } from "mdbreact";

import "./styles.css";

const BtnToTop = () => {
  window.onscroll = () => {
    const top = window.pageYOffset || document.documentElement.scrollTop;

    if (top > 900) {
      document.querySelector(".btn-to-top").classList.remove("d-none");
    } else {
      document.querySelector(".btn-to-top").classList.add("d-none");
    }
  };

  return (
    <div className="btn-to-top d-none">
      <Link to="accessibility-bar" smooth={true} duration={500}>
        <h5>
          <MDBIcon icon="chevron-up" />
        </h5>
      </Link>
    </div>
  );
};

export default BtnToTop;
